export default function formatRichText(html) {
  let newContent = html.replace(/<img[^>]*>/gi, function(match, capture) {
    match = match.replace(/style="[^"]+"/gi, '').replace(/style='[^']+'/gi, '');
    match = match.replace(/width="[^"]+"/gi, '').replace(/width='[^']+'/gi, '');
    match = match.replace(/height="[^"]+"/gi, '').replace(/height='[^']+'/gi, '');
    return match;
  });
  newContent = newContent.replace(/style="[^"]+"/gi, function(match, capture) {
    match = match.replace(/width:[^;]+;/gi, 'max-width:100%;').replace(/width:[^;]+;/gi, 'max-width:100%;');
    return match;
  });
  newContent = newContent.replace(/\r\n/gi, '<br>');
  
  // 添加对 table 标签的处理
  newContent = newContent.replace(/<table/gi, '<table class="rich-table"');
  
  newContent = newContent.replace(/\<img/gi,
    '<img style="max-width:100%;height:auto;display:inline-block;margin:10rpx auto;"');
  return newContent;
}